import React, {useState} from "react";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function Dia_Blood_Genes() {

const [dialogOpen, setdialogOpen] = useState(false);
const handleDialogOpen = () => {setdialogOpen(true);};
const handleDialogClose = () => {setdialogOpen(false);};

return(
<>      
        <Button onClick={handleDialogOpen} variant="outlined" size="small" sx={{ borderRadius:'16px', borderColor: 'common.white',mb:2, padding: '3px 8px 0px 8px',}} >
           <Typography variant="h6" color='common.white' gutterBottom 
                                sx={{fontWeight: '400', fontSize: {sx: '55%', sm: '45%', md: '75%', lg: '90%', xl: '80%' }, '&:hover': { color: 'primary.light'},   }}>
                                Associated Genes
            </Typography>
        </Button>


            <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth='xl'
                    sx={{ '& .MuiDialogContent-root': { display: 'flex', flexDirection: 'column', m: 'auto', width: '100%',}, 
                          '& .MuiDialogActions-root': { padding: 1,},}}>

                        <DialogTitle sx={{backgroundColor: 'background.default'}}>
                            <Typography  variant='h3' color='primary' align= 'center' sx={{fontFamily: 'Poppins', fontWeight: '500', mt:4}} >
                            BLOOD | LYMPH<br /> TESTED GENES
                            </Typography>
                        </DialogTitle>
                        
                        <DialogContent sx={{p:4, backgroundColor: 'background.default'}}>        
                                
                                <Typography variant='h5' color='primary' align='center'>
                                <br />
                                'TP53',<br /> 'MLLT2',<br /> 'MYC',<br /> 'ZNFN1A1',<br /> 'LAF4',<br /> 'ARNT',<br /> 'IRF1',<br /> 'RGS2',<br />
                                 'GMPS', <br />'AF10',<br /> 'CBFB',<br /> 'NUP98', <br />'NUP214',<br /> 'HOXA9', <br />'CREBBP',<br /> 'ARHGEF12',<br />
                                  'CDX2', <br />'LCP1', <br />'CEBPA', <br />'DEK',<br />'FUS',<br /> 'RUNX1',<br />'PML', <br />'THRA',<br /> 'NPM1', <br />
                                  'SET', <br />'BCL3',<br /> 'BTG1', <br />'PBXP1', <br />'DLEU1',<br /> 'DLEU2', <br />'AXL',<br /> 'EVI2A', <br />
                                  'EVI2B', <br />'CDC23', <br />'CLC', <br />'PBX1',<br /> 'PBX2',<br /> 'PBX3',<br /> 'TCL6', <br />TCL1B',<br />
                                   'MTCP1',<br /> 'LDB1', <br />'NOTCH1',<br /> 'NOTCH3',<br /> 'LYL1',<br /> 'HOX11', <br />'BAX', <br />'LMO1',<br />
                                    'LMO2',<br /> 'TAL1', <br />'TAL2',<br /> 'CAV1', <br />'NFKB2', <br />'ETS1', <br />'KIT',<br /> 'MLLT3', <br />
                                    'MLL3', <br />'LAF4',<br /> 'MYD88', <br />'BLC-2', <br />'TNF',<br /> 'IL-10',<br /> 'BRCA1', <br />'BRCA2',<br />
                                     'GTF2I',<br />'CDKN2A'<br />
                               
                                <br />
                                </Typography>

                                  </DialogContent>
                                  
                    <DialogActions sx={{backgroundColor: 'background.default'}}>
                        <Button onClick={handleDialogClose} sx={{m:4}}>BACK</Button>
                    </DialogActions>

            </Dialog>



</>
)}